


















































import { mapGetters, mapActions } from 'vuex'
import { trackEvent, SEGMENT_EVENTS } from '@/analytics/segment'
import OrderRoute from '@/components/order-common/OrderRoute.vue'
import { applyCustomErrorConfig, ServerStatusCode } from '@/custom-errors'

export default {
  components: {
    OrderRoute
  },
  props: {
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
    carrierId: { type: Number, required: true },
    selectedOrder: {
      type: Object,
      required: true,
      default: () => ({
        order: {},
        multiStop: {}
      })
    }
  },
  data() {
    return {
      priceMismatch: false,
      acceptNowHasFailed: false,
      acceptNowInitiated: false
    }
  },
  computed: {
    ...mapGetters(['updatedMarketplaceOrderIds']),
    routeDistance() {
      return this.selectedOrder.multiStop.routeDistance
    },
    acceptNowPrice() {
      const price = this.suggestedBaseCost
        ? `${this.suggestedBaseCost} €`
        : this.$t('marketPlace.requestModal.notAvailable')
      return `${this.$t('marketPlace.acceptNowModal.price')}: ${price}`
    },
    acceptTransport() {
      if (!this.selectedOrder.order) return ''
      return `${this.$t('marketPlace.acceptNowModal.title')} ${
        this.selectedOrder.order.idForStaff
      }`
    },
    suggestedBaseCost(): number {
      return this.selectedOrder.order?.suggestedBaseCost || 0
    }
  },
  methods: {
    ...mapActions(['submitAcceptNow']),
    close() {
      this.$emit('close')
    },
    onShown() {
      // TODO: test with real accept now flow (On the next shown it should be false by default, no need for re-sets)
      this.acceptNowInitiated = false
    },
    stepBack() {
      this.$emit('close', true)
    },
    async handleConfirm() {
      this.acceptNowInitiated = true
      const suggestedSpotCost = this.selectedOrder.order?.suggestedBaseCost || 0
      const price = suggestedSpotCost ? parseFloat(suggestedSpotCost.toFixed(2)) : null
      try {
        await this.submitAcceptNow({
          order: this.selectedOrder.order.id,
          price,
          suggested_cost: price
        })

        trackEvent(SEGMENT_EVENTS.MAO_ACCEPT_NOW_REQUEST_SUCCESS, {
          carrierId: this.carrierId,
          isRelevant: this.selectedOrder.order?.isRelevant,
          orderId: this.selectedOrder.order?.id
        })
      } catch (error) {
        trackEvent(SEGMENT_EVENTS.MAO_ACCEPT_NOW_REQUEST_FAILURE, {
          carrierId: this.carrierId,
          isRelevant: this.selectedOrder.order?.isRelevant,
          orderId: this.selectedOrder.order?.id
        })

        this.acceptNowHasFailed = true
        this.acceptNowInitiated = false
        if (!error.response) {
          return
        }
        const status = error.response.status
        const message = error.response.data

        switch (status) {
          case ServerStatusCode.Conflict: {
            this.alertModal.showErrorMessage(
              this.$t('serverError.title'),
              this.$t('marketPlace.acceptNow.error.alreadyAcceptedOrAssigned'),
              applyCustomErrorConfig
            )
            break
          }
          case ServerStatusCode.BadGateway: {
            this.alertModal.showErrorMessage(
              this.$t('serverError.title'),
              this.$t('serverError.msg'),
              applyCustomErrorConfig
            )
            break
          }
          case ServerStatusCode.PreconditionFailed: {
            this.alertModal.showErrorMessage(
              this.$t('serverError.title'),
              this.$t('marketPlace.acceptNow.error.priceMismatch'),
              applyCustomErrorConfig
            )
            this.priceMismatch = true
            break
          }
          default: {
            this.alertModal.showErrorMessage(
              this.$t('serverError.title'),
              message,
              applyCustomErrorConfig
            )
          }
        }
      } finally {
        trackEvent(SEGMENT_EVENTS.MAO_ACCEPT_NOW_REQUEST_SENT, {
          carrierId: this.carrierId,
          isRelevant: this.selectedOrder.order?.isRelevant,
          orderId: this.selectedOrder.order?.id
        })

        this.$emit('submit', this.priceMismatch, this.acceptNowHasFailed)
      }
    }
  }
}
